<div data-collapse="medium" data-animation="default" data-duration="400" data-w-id="6cb710cf-def5-5114-6821-05b6e49c1f63" data-easing="ease" data-easing2="ease" role="banner" class="navbar w-nav">
    <div class="container-m container-navbar">
      <div class="navbar-brand-wrapper">
        <a [routerLink]="['']" aria-current="page" class="navbar-brand w-nav-brand w--current"><img src="../../assets/images/Gruppe-694.svg" loading="lazy" width="158" alt="Hudson Logo" class="brand-image-white"></a>
      </div>
      <div class="navbar-cta-wrapper-mobil"></div>
      <div class="menu-button w-nav-button">
        <div class="icon hide w-icon-nav-menu"></div>
        <div class="burger-wrapper">
          <div class="burger-line p1"></div>
          <div class="burger-line p2"></div>
          <div class="burger-line p3"></div>
        </div>
      </div>
      <nav role="navigation" class="navbar-menu w-nav-menu">
        <div class="navbar-col-1">
          <a [routerLink]="['/buy-properties']" class="navbar-link l-0rem text-lighter w-nav-link">Buy</a>
          <a href="rent-properties.html" class="navbar-link l-0rem text-lighter w-nav-link">Rent</a>
          <a [routerLink]="['/services']" class="navbar-link l-0rem text-lighter w-nav-link">Services</a>
        </div>
        <div class="navbar-col-2">
          <a href="tel:+97145693115" class="navbar-link-icon text-background w-inline-block"><img src="../../assets/images/phone.svg" loading="lazy" width="15" alt="" class="image icon-whatsapp">
            <div>+971 4 380 5710</div>
          </a>
          <a href="https://wa.me/971521093760?text=Hi%20Hudson,%20I%20have%20an%20inquiry" class="navbar-link-icon text-background w-inline-block"><img src="../../assets/images/whatsapp.svg" loading="lazy" width="15" alt="" class="image icon-whatsapp">
            <div>Whatsapp</div>
          </a>
          <div class="navbar__cta-wrap">
            <a [routerLink]="['/buy-properties']" class="button button-primary nav-button w-button">Property to buy</a>
          </div>
        </div>
      </nav>
    </div>
    <div class="bg-section bg-nav"></div>
  </div>